import Cursor from '@/components/common/cusor';
import Lines from '@/components/common/Lines';
import ProgressScroll from '@/components/common/ProgressScroll';
import Footer from '@/components/home-main/Footer';
import Navbar from '@/components/home-main/Navbar';
import Header from '@/pages/landingpage/services-pages/project1/components/Header';
import { Helmet } from 'react-helmet';
import DigitalProducts from '@/components/home-main/DigitalProducts';
import AssetsIntro from './components/AssetsIntro';
import DigitalStory from './components/DigitalStory';

export default function DigitalAssets() {
  return (
    <>
      <Helmet>
        <title>Digital Assets</title>
        <link rel="icon" href="/light/assets/imgs/fox.webp" />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/plugins.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/style.css"
        />
 
        <script src="/light/assets/js/scripts.js"></script>
        <script src="/light/assets/js/smoother-script.js"></script>
      </Helmet>
      <main>
        <Cursor />
        <ProgressScroll />
        <Lines />
        <div id="smooth-wrapper">
          <Navbar />
          <div id="smooth-content">
            <main className="main-bg">
              <Header title='GCAD Digital Assets' bgImg='https://www.bbva.com/wp-content/uploads/2020/12/blockchain-1024x629.jpg'/>
              <AssetsIntro />
              <DigitalProducts/>
              <DigitalStory />
            </main>
            <Footer />
          </div>
        </div>
      </main>
    </>
  );
}
